import { useQuery } from '@tanstack/react-query';
import type { inferOutput } from '@trpc/tanstack-react-query';
import { useTRPC } from '../../../../lib/trpc';

type TRPC = ReturnType<typeof useTRPC>;
export type PerformanceReport = inferOutput<TRPC['performanceReport']['report']>;
export type PeriodTotals = PerformanceReport['periods']['current'];
export type MatrixEntry = PerformanceReport['matrix']['quadrants']['scale'][number];
export type QuadrantName = keyof PerformanceReport['matrix']['quadrants'];
export type QuadrantTag = PerformanceReport['matrix']['topTags']['scale'][number];
export type DnaTag = PerformanceReport['dna'][number];
export type Performer = PerformanceReport['performers']['top'][number];
export type ProjectionRow = PerformanceReport['projections'][number];
export type TrendPoint = PerformanceReport['trend'][number];
export type EligibleTag = PerformanceReport['actions']['scale'][number];

export interface ReportRequest {
  dateRange: [string, string];
  creativeType: string[];
  kpi: string;
  accountIds: number[];
}

export function usePerformanceReport(request: ReportRequest) {
  const trpc = useTRPC();
  return useQuery({
    ...trpc.performanceReport.report.queryOptions({
      dateRange: request.dateRange,
      kpi: request.kpi,
      ...(request.creativeType.length > 0
        ? { filters: { creativeType: request.creativeType } }
        : {}),
      ...(request.accountIds.length > 0 ? { accountIds: request.accountIds } : {}),
    }),
    // Before the client list resolves accountIds is empty, which the server reads as "every
    // account" — an expensive query and a flash of an unscoped report.
    enabled: request.kpi.length > 0 && request.accountIds.length > 0,
  });
}
